import { action } from "satcheljs";

const defaultExport: () => {} = action("onAppHostHeaderStartSearch");
export default defaultExport;
